import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  openNewbuildingBrokerCallbackWidget,
  setGalleryBannerAnalyticsSent,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { NewbuildingBrokerGalleryBanner } from 'shared/components/NewbuildingBrokerGalleryBanner';
import { useOfferBookingUrl } from 'shared/hooks/useOfferBookingUrl';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { selectFullscreenGalleryOpened } from 'shared/selectors/gallery';
import { selectGalleryBannerAnalyticsSent } from 'shared/selectors/newbuildingBrokerOfferBooking';
import { trackBookingButtonClick, trackCallbackWidgetOpen } from 'shared/utils/newbuildingBrokerOfferBooking';

import { trackBookingButtonShow } from './tracking';

export const NewbuildingBrokerGalleryBannerContainer = () => {
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);
  const offerBookingUrl = useOfferBookingUrl('offer_card_gallery_banner');
  const gaLabel = useSelector(getOfferCustomUrl);
  const galleryBannerAnalyticsSent = useSelector(selectGalleryBannerAnalyticsSent);

  const dispatch = useDispatch();

  const handleBookingShow = React.useCallback(() => {
    if (!galleryBannerAnalyticsSent) {
      trackBookingButtonShow();
      dispatch(setGalleryBannerAnalyticsSent());
    }
  }, [dispatch, galleryBannerAnalyticsSent]);

  const handleBookingClick = React.useCallback(() => {
    trackBookingButtonClick(gaLabel, 'gallery');
  }, [gaLabel]);

  const handleDetailsClick = React.useCallback(() => {
    dispatch(openNewbuildingBrokerCallbackWidget('gallery_label'));
    trackCallbackWidgetOpen(gaLabel, 'gallery');
  }, [dispatch, gaLabel]);

  return (
    <NewbuildingBrokerGalleryBanner
      isFullscreen={isFullscreen}
      buttons={
        <>
          <Button theme="stroke_primary" onClick={handleDetailsClick}>
            Узнать подробности
          </Button>
          <ActionAfterViewObserver callback={handleBookingShow} wrapper={false}>
            <LinkButton theme="fill_primary" href={offerBookingUrl} onClick={handleBookingClick}>
              Заполнить заявку
            </LinkButton>
          </ActionAfterViewObserver>
        </>
      }
    />
  );
};
